import React, { Component } from 'react'

import { MuiTypography, MuiGrid, MuiDialogContent, MuiDialogActions, MuiDialogTitle, MuiButton, MuiDialog, MuiDivider, MuiDialogContentText, muiWithStyles } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
export default class AlertDialogComponent extends Component {
    render() {
        return (
            <MuiGrid>
                <MuiDialog
                    id="dialog"
                    open={this.props.openDialog}
                    onClose={this.props.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
                        <MuiGrid container>
                            <MuiGrid item xs container alignItems="center" justify="center" >
                                <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                                    {this.props.title}
                                </MuiTypography>
                            </MuiGrid>
                        </MuiGrid>
                    </MuiDialogTitle>

                    <MuiDialogContent>
                        <MuiGrid container xs={12} alignContent="center" justify="center">
                            <MuiTypography style={theme.typography.body2}>
                                {this.props.text}
                            </MuiTypography>
                        </MuiGrid>
                    </MuiDialogContent>
                    <MuiDialogActions>
                        <MuiGrid container spacing={2} align="center" justify='flex-end'>

                            <MuiGrid item >
                                <MuiButton
                                    onClick={this.props.actionNameForNo !== undefined ? ()=>this.props.handleReject() : () => this.props.handleCloseDialog()}
                                    style={theme.secondaryButtonStyle}
                                >
                                    {this.props.actionNameForNo !== undefined ? this.props.actionNameForNo : "NO"}
                                </MuiButton>
                            </MuiGrid>
                            <MuiGrid item  >
                                <MuiButton

                                    style={theme.primaryButtonStyle}
                                    onClick={() => this.props.handleClickOnYes()}
                                >
                                    {this.props.actionNameForYes !== undefined ? this.props.actionNameForYes : "YES"}
                                </MuiButton>
                            </MuiGrid>

                        </MuiGrid>
                    </MuiDialogActions>
                </MuiDialog>
            </MuiGrid>
        );
    }
}

AlertDialogComponent.defaultProps = {
    text: 'Are you sure to continue ?'
}